export default __webpack_public_path__ + "static/media/8 raw.4bc2fe41.mp3";